export const dateTimeFormats = {
	short: {
		month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
	},
	medium: {
		year: 'numeric', month: 'short', day: 'numeric'
	},
	long: {
		year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
	},
	full: {
		year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric'
	}
};
export const messages = {
    "login.form.title": "Daftar masuk",
    "login.form.hint.user": "Log masuk",
    "login.form.hint.password": "Kata laluan",
    "login.form.checkbox.remember-me": "Ingat saya",
    "login.form.button.sign-in": "Daftar masuk",
    "login.form.message.invalid-user-credentials": "Log masuk atau kata laluan salah",
    "login.form.message.account-temporarily-locked": "Akaun anda dikunci buat sementara waktu, kembali semula dalam masa 5 minit",
    "login.form.message.user-required": "Masukkan log masuk",
    "login.form.message.password-required": "Masukkan kata laluan",
    "login.form.button.forgot-password": "Lupa kata laluan?",
    "error.mfa-required.title": "Tetapkan 2FA",
    "error.mfa-required.message1": "Pengesahan dua faktor (2FA) diperlukan untuk melindungi akaun anda.",
    "error.mfa-required.message2": "Anda akan diarahkan semula ke tetapan akaun anda dalam Online Dashboard. Dayakan 2FA, ikuti arahan penetapan, kemudian kembali ke sini.",
    "error.mfa-required.learnMore": "Ketahui lebih lanjut tentang 2FA",
    "error.mfa-required.continue": "Teruskan",
    "error.root-admin-login.title": "Ralat 403 – dilarang",
    "error.root-admin-login.message": "Anda telah mengelog masuk sebagai Pentadbir Baca Sahaja. Untuk mengakses konsol Web Recovery, sila log masuk sebagai pengguna atau pentadbir penyewa pelanggan",
    "error.server-busy.message": "Pelayan sedang sibuk, sila cuba lagi nanti.",
    "error.network-connection.title": "Ralat sambungan rangkaian",
    "error.network-connection.message": "Periksa sambungan Internet anda dan cuba lagi.",
    "error.internal-server-error.title": "Ralat pelayan dalaman",
    "error.internal-server-error.message": "Untuk menetapkan ralat, hubungi sokongan dengan butiran ralat:",
    "error.internal-server-error.copy.button": "Salin"
};
